import React from 'react'

import { LayoutContentWrapper } from 'goustouicomponents'
import Immutable from 'immutable'
import PropTypes from 'prop-types'

import { Item } from 'components/Item'

import { UnavailableMessage } from '../UnavailableMessage'

import css from '../Details.css'

class RecipeList extends React.PureComponent {
  componentDidMount() {
    const { trackingUnavailableRecipeList, menuFetchPending } = this.props

    const unavailableRecipes = this.getUnavailableRecipes()

    if (unavailableRecipes.length > 0 && !menuFetchPending) {
      trackingUnavailableRecipeList(unavailableRecipes)
    }
  }

  getBasketRecipes() {
    const { recipes, coreIdToUUIDMap, basketRecipes: basketRecipeQuantities } = this.props

    const basketRecipeQuantitiesByCoreId = basketRecipeQuantities.toJS()
    const basketRecipeUUIDs = Object.keys(basketRecipeQuantitiesByCoreId)
      .map((recipeCoreId) => coreIdToUUIDMap[recipeCoreId])
      .filter((uuid) => Boolean(uuid))

    return basketRecipeUUIDs.map((uuid) => recipes[uuid]).filter((recipe) => Boolean(recipe))
  }

  getUnavailableRecipes() {
    const { unavailableRecipeIds } = this.props

    const basketRecipes = this.getBasketRecipes()
    const unavailableRecipeIdsMap = unavailableRecipeIds.toJS()

    return basketRecipes.filter((recipe) => Boolean(unavailableRecipeIdsMap[recipe.coreId]))
  }

  getOkRecipes() {
    const { okRecipeIds } = this.props

    const basketRecipes = this.getBasketRecipes()
    const okRecipeIdsMap = okRecipeIds.toJS()

    return basketRecipes.filter((recipe) => Boolean(okRecipeIdsMap[recipe.coreId]))
  }

  render() {
    const {
      basketRecipes,
      menuFetchPending,
      numPortions,
      removeRecipeFromBasket,
      orderSaveError,
      showRecipeDetailsOnClick,
      basketRestorePreviousDate,
      clearSlot,
      forceSquareRecipeImages,
      hideRecipeTitleArrow,
    } = this.props

    const okRecipes = this.getOkRecipes()
    const unavailableRecipes = this.getUnavailableRecipes()

    return (
      <div>
        <LayoutContentWrapper>
          <div className={css.recipeItems}>
            {okRecipes.map((recipe) => (
              <Item
                key={recipe.coreId}
                type="recipe"
                available
                fromBox
                media={Immutable.fromJS(
                  recipe.images?.[0]?.crops.map((crop) => ({
                    src: crop.url,
                    width: crop.width,
                  })),
                )}
                onImageClick={() => showRecipeDetailsOnClick(recipe.coreId)}
                onRemove={() => removeRecipeFromBasket(recipe.coreId, 'boxSummaryMinus')}
                quantity={basketRecipes.get(recipe.coreId) * numPortions}
                recipeId={recipe.coreId}
                title={recipe.name}
                forceSquareImage={forceSquareRecipeImages}
                hideArrowRight={hideRecipeTitleArrow}
                isHeatOnly={recipe.preparationType === 'heat-only'}
              />
            ))}

            <UnavailableMessage
              basketRestorePreviousDate={basketRestorePreviousDate}
              clearSlot={clearSlot}
              unavailableRecipeList={unavailableRecipes}
              menuFetchPending={menuFetchPending}
              orderSaveError={orderSaveError}
            />

            {unavailableRecipes.map((recipe) => (
              <Item
                key={recipe.coreId}
                type="recipe"
                available={menuFetchPending}
                media={Immutable.fromJS(
                  recipe.images?.[0]?.crops.map((crop) => ({
                    src: crop.url,
                    width: crop.width,
                  })),
                )}
                onImageClick={() => showRecipeDetailsOnClick(recipe.coreId)}
                onRemove={() => removeRecipeFromBasket(recipe.coreId, 'boxSummaryMinus')}
                quantity={basketRecipes.get(recipe.coreId) * numPortions}
                title={recipe.name}
                isHeatOnly={recipe.preparationType === 'heat-only'}
              />
            ))}
          </div>
        </LayoutContentWrapper>
      </div>
    )
  }
}

RecipeList.propTypes = {
  recipes: PropTypes.objectOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      coreId: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      images: PropTypes.arrayOf(
        PropTypes.shape({
          type: PropTypes.string.isRequired,
          crops: PropTypes.arrayOf(
            PropTypes.shape({
              url: PropTypes.string.isRequired,
              width: PropTypes.number.isRequired,
            }),
          ),
        }),
      ),
    }),
  ).isRequired,
  coreIdToUUIDMap: PropTypes.objectOf(PropTypes.string).isRequired,
  basketRecipes: PropTypes.instanceOf(Immutable.Map).isRequired,
  menuFetchPending: PropTypes.bool.isRequired,
  numPortions: PropTypes.number.isRequired,
  okRecipeIds: PropTypes.instanceOf(Immutable.Map).isRequired,
  removeRecipeFromBasket: PropTypes.func.isRequired,
  orderSaveError: PropTypes.string.isRequired,
  showRecipeDetailsOnClick: PropTypes.func.isRequired,
  unavailableRecipeIds: PropTypes.instanceOf(Immutable.Map).isRequired,
  basketRestorePreviousDate: PropTypes.func.isRequired,
  clearSlot: PropTypes.func.isRequired,
  trackingUnavailableRecipeList: PropTypes.func.isRequired,
  forceSquareRecipeImages: PropTypes.bool,
  hideRecipeTitleArrow: PropTypes.bool,
}

RecipeList.defaultProps = {
  forceSquareRecipeImages: false,
  hideRecipeTitleArrow: false,
}

export { RecipeList }
